import React, { Component } from "react";
import DataTable from 'react-data-table-component';
import history from "../login/history";
import AuthService from "../../../services/login/auth.service";
import ButtonLink from "../../generico/ButtonLink";
import ConfigService from "../../../services/configuracion/ConfigService";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye , faPencil } from "@fortawesome/free-solid-svg-icons";
import Popup from "react-popup";
import resumenSocioService from "../../../services/resumenGeneral/resumenSocioService";
import { trackPromise } from "react-promise-tracker";


const paginationOptions = {
  rangeSeparatorText: "de",
  rowsPerPageText: 'Filas por página',
  selectAllRowsItem: true,
  selectAllRowsItemText: 'Todos'
  //noRowsPerPage:true
};

const MOVIMIENTO_AHORRO_VISTA = 60;



const DetalleFila = ({ data }) => (
  <div className="row" style={{ margin: 0, fontSize: 13, marginBottom: 20 }}>
    <div className="col-md-12">
      <p style={{ fontWeight: 500, marginBottom: 0 }}>Detalles:</p>
      <br/>
    </div>
    <div className="col-md-3">
      <p style={{ marginBottom: 0 }}>Fecha Apertura: {data.fechaApertura}</p>
    </div>
    <div className="col-md-2">
      <p style={{ marginBottom: 0 }}>Saldo Retenido: {data.saldoRetenido}</p>
    </div>
    <div className="col-md-2">
      <p style={{ marginBottom: 0 }}>Monto Bloqueado: {data.saldoBloqueado}</p>
    </div>
    <div className="col-md-2">
      <p style={{ marginBottom: 0 }}>Monto Garantía: {data.saldoGarantia}</p>
    </div>
    <div className="col-md-2">
      <p style={{ marginBottom: 0 }}>Monto Caucionado: {data.saldoCaucionado}</p>
    </div>
  </div>
);

export default class AHVista extends Component {
  constructor(props) {
    super(props);

    this.state = {
      nombreSocio: "",
      cedulaSocio: "",
      cuentaSocio: "",
      cuenta:null,
      nombreCuenta:''
    }

  }

  callPopupAndSetCuenta (titulo,row) {
    this.setState({cuenta:row?.ahorro , nombreCuenta:row?.etiqueta});
    this.notifiPopupWithInput(titulo , row);
  }

  notifiPopup( titulo , mensaje ){
    Popup.create({
      tittle:titulo,
      content : mensaje,
      buttons:{
        right:[
          {
            text: "Aceptar",
            className: "success",
            action: ()=>{
              Popup.close();
            },
        },
        ]
      }
    })
  }

  notifiPopupWithInput ( titulo , row ) {
    let inputValue='';
    Popup.create({
        title: titulo,
        content: (
            <div className="modal-body align-items-center">
                <p style={{fontFamily:'Montserrat-Medium',fontSize:'15px'}}>
                  Introducir el nombre de su cuenta:
                </p>
                <input
                    type="text"
                    className="form-control input-box"
                    placeholder={'Introduzca'}
                    onChange={ (e) => {
                      inputValue = e.target.value;
                    }}
                />
            </div>
        ),
        buttons: {
            right: [
                {
                    text: "Aceptar",
                    className: "success",
                    action: ()=>{
                      this.changeEtiqueta(row?.ahorro , inputValue);
                      Popup.close();
                    },
                },
                {
                  text:'Cancelar',
                  className : "secundary",
                  action: ()=>{Popup.close()}
                }
            ],
        },
    });
}

  componentDidMount() {
    //console.log(AuthService.getCurrentUser());
    let usuario = AuthService.getCurrentUser();

    this.setState({
      nombreSocio: usuario.nombreCompleto,
      cedulaSocio: usuario.cedulaIdentidad
    })

  }

  changeEtiqueta (numeroCuenta , newEtiqueta){
    let body = {
      idAhorro : numeroCuenta,
      etiqueta : newEtiqueta
    }
    trackPromise(
      resumenSocioService.modificarEtiqueta(body)
      .then( ({status , data }) =>{
        if( status === 200 ){
          if( data.codigo === 0 ){
            this.props.ahorros.forEach(element => {
              if( element.ahorro === numeroCuenta ){
                this.setState({ nombreCuenta : newEtiqueta });
                element.etiqueta = newEtiqueta;
              }
            });
            this.forceUpdate();
          }else{
            Popup.queue( this.notifiPopup( 'Error' , data.mensajeServidor ) );
            console.error('data.codigo distinto de 0');
          }
        }else{
          console.error('status distinto a 200');
          Popup.queue( this.notifiPopup( 'Error' , 'Ha ocurrido un error al momento de actualizar el nombre de la cuenta. Por favor intente más tarde.' ) );
        }
      })
    )
  }

  getColumnDetalle() {
    return [
      {
        name: "Cuenta",
        selector: row => row.ahorro
      },
      {
        name: "Tipo",
        selector: row => row.descripcion,
        width: "150px"
      },
      {
        name: "Moneda",
        selector:  row => row.moneda,
        width: "70px"
      },
      {
        name: "Fecha Apertura",
        selector: row => row.fechaApertura,
        omit: true
      },
      {
        name: "Saldo Actual",
        selector: row => row.saldoActual,
        right: true
      },
      {
        name: "Saldo Retenido",
        selector: row => row.saldoRetenido,
        right: true,
        omit: true
      },
      {
        name: "Saldo Disponible",
        selector: row => row.disponible,
        right: true
      },
      {
        name: "Monto Bloqueado",
        selector: row => row.saldoBloqueado,
        right: true,
        omit: true
      },
      {
        name: "Monto Garantía",
        selector: row => row.saldoGarantia,
        right: true,
        omit: true
      },
      {
        name: "Monto Cauciado",
        selector: row => row.saldoCaucionado,
        right: true,
        omit: true
      },
      {
        name: "Etiqueta",
        selector: row => row.etiqueta ? row.etiqueta.toUpperCase() : 'CUENTA DE AHORRO',
      },
      {
        cell: (row) => (
          // <div style={{ display: "flex", flexDirection: "column" }}>
          <div className="flex flex-col space-y-2 p-2">
            <ButtonLink
              className="btn btn-cu-terciary btn-table-action"
              // style={{ whiteSpace: "nowrap" }}
              url={ConfigService.getPathById(MOVIMIENTO_AHORRO_VISTA)?.url}
              param={row}
              onClick={this.movimientos}>
              <FontAwesomeIcon icon={faEye} className="text-white" />  Ver Movimientos
            </ButtonLink>
            <button
              className="btn btn-cu-terciary btn-table-action"
              onClick={()=>{
                this.callPopupAndSetCuenta('Etiqueta de Cuenta',row)
              }}
            >
              <FontAwesomeIcon className="text-white" icon={faPencil} />Modificar Etiqueta
            </button>
            {/* <ModalModificacionEtiqueta 
              cuenta={this.state.cuenta}
              changeEtiqueta={this.changeEtiqueta.bind(this)}
            /> */}
          </div>
        ),
        right: true,
        width: "250px"
      }
    ];
  }

  movimientos = (url, row) => {
    sessionStorage.setItem("AH", row.ahorro);
    sessionStorage.setItem("tipo", "AH");
    history.push(url);
    window.location.reload();
  }

  mostrarDatosTransferencia = ({ nombre, cedula, cuenta }) => {
    return (
      <div className="modal fade" id="modal-datos-transferencia" data-backdrop="true" >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              {/* <h5 className="modal-title d-xs-none">Datos para Transferencia</h5> */}
              <h5 className="modal-title d-sm-none d-md-none d-lg-none">Transferencias por SIPAP</h5>
              <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="card card-datos-transferencia">
                <div className="card-body">
                  <div className="row">
                    <div className="col-6 col-xs" style={{ padding: 0 }}>
                      <img className="img-movil-cu" src="dist/img/Logo_CU_Verde.PNG" width="170px" alt="" />
                    </div>
                    <div className="col-6 d-flex">
                      <img className="img-movil-bcp" src="dist/img/logo_bcp.png" width="85px" alt="" style={{ position: "relative", top: "-10px" }} />
                    </div>
                    <div className="col-6 col-xs" style={{ padding: 0 }}>
                      <img className="img-movil-cu" src="dist/img/Logo_CU_Verde.PNG" width="170px" alt="" />
                    </div>
                    <div className="col-6 d-flex">
                      <img className="img-movil-bcp" src="dist/img/logo_bcp.png" width="85px" alt="" style={{ position: "relative", top: "-10px" }} />
                      <p className="card-text text-sipap">Transferencias por SIPAP</p>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-12">
                      <p className="card-title titulo-titular">Para Transferir a:</p>
                      <p className="card-text nombre-titular">{nombre}</p>
                    </div>
                  </div>
                  <div className="row" style={{ marginTop: 10 }}>
                    <div className="col-md-3 col-sm-12 col-md-4">
                      <p className="card-title">N° Cédula</p>
                      <p className="card-text">{cedula}</p>
                    </div>
                    <div className="col-md-5 col-xs-12 col-sm-12">
                      <p className="card-title">Cuenta</p>
                      <p className="card-text">{cuenta}</p>
                    </div>
                    <div className="col-md-3 col-xs-12 col-sm-12" style={{ height: "5rem" }}>
                      <p className="card-title">Banco</p>
                      <img className="card-text" src="dist/img/logo_basa.png" width="120px" alt=""
                        style={{ position: "relative", top: "-50px" }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div >
          </div>
        </div>
      </div >
    )
  }

  render() {

    return (
      <>
        <DataTable
        className="vista"
          noHeader={true}
          pagination={true}
          columns={this.getColumnDetalle()}
          data={this.props.ahorros}
          paginationComponentOptions={paginationOptions}
          noDataComponent="no hay registros para mostrar"
          responsive={true}
          striped={true}
          // expandableRows
          // expandableRowsComponent={
          //   <DetalleFila data={this.props.ahorros} />
          // } 
          expandableRows
          expandableRowsComponent={DetalleFila}
          />
        <this.mostrarDatosTransferencia
          nombre={this.state.nombreSocio}
          cedula={this.state.cedulaSocio}
          cuenta={this.state.cuentaSocio}
        />
      </>
    );

  }
}